import { render } from "./TradeDropdown.vue?vue&type=template&id=584a3462"
import script from "./TradeDropdown.vue?vue&type=script&lang=js"
export * from "./TradeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__